import script from "./DestinationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationForm.vue?vue&type=script&setup=true&lang=js"

import "./DestinationForm.vue?vue&type=style&index=0&id=e7b2ea5c&lang=css"
import "./DestinationForm.vue?vue&type=style&index=1&id=e7b2ea5c&scoped=true&lang=css"

import exportComponent from "C:\\wisata-jepara-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7b2ea5c"]])

export default __exports__